<template>
  <div class="contract-detail-dialog">
    <el-dialog
      title="合同详情"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose">
      <div>
        <div class="content-title">
          合同预览：
          <span v-for="(item, index) in contimgs" :key="index">
            <el-button type="text" @click="reviewContract(item.storageName)"
              >{{ item.originalName || "" }}
            </el-button>
          </span>
        </div>
        <div>操作记录</div>
        <div class="divider-line"></div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="操作时间" prop="createTime" min-width="120">
            <template slot-scope="scope">{{ scope.row.createTime | formatCreateTime }}</template>
          </el-table-column>
          <el-table-column label="原合同" prop="oldOriginalName" min-width="60">
            <template slot-scope="scope" v-if="scope.row.oldOriginalName">
              <el-button type="text" size="mini" @click="reviewContract(scope.row.oldStorageName)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="新合同" prop="newOriginalName" min-width="60">
            <template slot-scope="scope" v-if="scope.row.newOriginalName">
              <el-button type="text" size="mini" @click="reviewContract(scope.row.newStorageName)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="更换原因"
            prop="reason"
            show-overflow-tooltip
            min-width="120"></el-table-column>
          <el-table-column label="更换合同凭证" prop="voucherOriginalName" min-width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="reviewVoucherOriginal(scope.row.voucherStorageName)"
                v-if="scope.row.voucherOriginalName"
                >查看</el-button
              >
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column label="操作人" prop="operateName" min-width="60"></el-table-column>
          <el-table-column label="操作人手机号" prop="telephone" min-width="80"></el-table-column>
          <el-table-column label="操作IP" prop="ip" min-width="80"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 查看图片弹窗 -->
    <el-dialog title="预览" :visible.sync="contractVisible" center>
      <div style="text-align: center; width: 100%">
        <el-image style="width: 100px; height: 100px" :src="urls" :preview-src-list="srcList">
        </el-image>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="contractVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getContractLogDetail } from "@/api/userCenters.js";
import { formatDate } from "@/utils/date.js";

const { baseUrl } = require("@/config");

export default {
  data() {
    return {
      baseUrl: baseUrl,
      /** 弹窗开关 */
      dialogVisible: false,
      /** 预览合同弹窗开关 */
      contractVisible: false,
      urls: "",
      srcList: [],
      /** 合同图片列表 */
      contimgs: [],
      /** 列表数据 */
      tableData: [],
    };
  },
  filters: {
    /** 时间过滤器 */
    formatCreateTime(time) {
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    /** 查看合同 */
    reviewContract(url) {
      let str = this.baseUrl + "third/third/ossGetFile/" + url;
      window.open(str);
    },
    /** 查看凭证附件 */
    reviewVoucherOriginal(url) {
      let str = this.baseUrl + "third/third/ossGetFile/" + url;
      this.urls = str;
      this.srcList.push(str);
      this.contractVisible = true;
    },
    open(data) {
      // console.log("getContractLogDetail.open", data);
      let list = data.contractUrls;
      let newlist = data.annexUrls;
      let mergeArray = list.concat(newlist);
      this.contimgs = mergeArray;
      this.dialogVisible = true;
      getContractLogDetail({ orderId: data.orderId }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleClose() {
      /** 合同图片列表 */
      this.contimgs = [];
      /** 列表数据 */
      this.tableData = [];
      this.urls = "";
      this.srcList = [];
      /** 预览合同弹窗开关 */
      this.contractVisible = false;
      /** 弹窗开关 */
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-detail-dialog {
  .content-title {
    margin: 5px 0 20px 40px;
    font-weight: 500;
  }
  .divider-line {
    border-bottom: 1px solid #b2b2b2;
    width: calc(100% + 40px);
    transform: translateX(-20px);
    margin: 10px 0 20px 0;
  }
  .flexItem {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .ItemClass {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-left: 10px;
  }

  ::v-deep .el-dialog__body {
    padding: 0 20px;
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
}
</style>
